import { render, staticRenderFns } from "./webHander.vue?vue&type=template&id=02389314&scoped=true&"
import script from "./webHander.vue?vue&type=script&lang=js&"
export * from "./webHander.vue?vue&type=script&lang=js&"
import style0 from "./webHander.vue?vue&type=style&index=0&id=02389314&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02389314",
  null
  
)

export default component.exports